export default __webpack_public_path__ + "static/media/promotions-pic-5.ae5e9b06.jpg";